import { createRouter, createWebHistory } from 'vue-router'

const routes = [
    {
      path: '/',
      name: 'Strona główna',
      component: () => import('../views/Home')
    },
    {
      path: '/ofirmie',
      name: 'O firmie',
      component: () => import('../views/AboutUs')
    },
    {
      path: '/oferta',
      name: 'Oferta',
      component: () => import('../views/Oferta')
    },
    {
      path: '/dostawcy',
      name: 'Dostawcy',
      component: () => import('../views/Dostawcy')
    },
    {
      path: '/kontakt',
      name: 'Kontakt',
      component: () => import('../views/Contacts')
    }
  ]
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router

